import { render, staticRenderFns } from "./AppBadge.vue?vue&type=template&id=479109eb&"
import script from "./AppBadge.vue?vue&type=script&lang=js&"
export * from "./AppBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports